import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const deleteQuery = async (queryId) => {
  const token = localStorage.getItem("token");

  await axios.delete(`${__API_URL__}/api/ecrf/delete_query/${queryId}/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
};

const useDeleteQueryMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteQuery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["query_logs"] });
    },
  });
};

export default useDeleteQueryMutation;
